import { translate } from '../../../utils/translation'

export const useLatestMovementsTranslation = () => ({
  latestMovements: translate('Últimas movimentações'),
  notIdentified: translate('Não identificado'),
  seeExtract: translate('Ver extrato'),
  credit: translate('Crédito'),
  debit: translate('Débito'),
  cash: translate('Cash'),
  points: translate('Pontos'),
  credited: translate('Creditado'),
  debited: translate('Debitado'),
  pending: translate('Pendente'),
  confirmed: translate('Confirmado'),
  canceled: translate('Cancelado'),
})
